import React, { useMemo, useRef, useState } from 'react';

import cn from 'classnames';

import { THEME } from '@constants/base';
import { useIsomorphicLayoutEffect } from '@lib/hooks'
import { I18n } from '@utils/index';

import { initTabLogin, initTabRegister } from '../utils'

import styles from './index.module.less';

const titleMap = () => ({
  login: I18n.t('Kikitrade.Account.Login'),
  register: I18n.t('register_title')
});

type LoginOrRegisterType = 'login' | 'register';

interface LoginRegisterProps {
  defaultType?: LoginOrRegisterType;
  loginOrRegister?: LoginOrRegisterType; // 默认展示登录模块或注册模块
  title?: { login: string; register: string };
  titleClassName?: string;
  className?: string; // 最外层box
  loginDefaultKey?: '1' | '2';
  registerDefaultKey?: '1' | '2';
  close?: () => void;
  /** 主题 */
  theme?: Theme;
  cb?: (params: any) => void;
}

export const Main: React.FC<LoginRegisterProps> = (props) => {
  const { title = titleMap(), titleClassName, className, defaultType = 'login', close, theme, cb } = props;
  const divRef = useRef();
  const fnRef = useRef<any>({});
  const [loginOrRegister, setLoginOrRegiste] = useState<LoginOrRegisterType>(defaultType);

  const loginRegisterTabsHandle = () => {
    if (loginOrRegister === 'login') {
      fnRef.current.login.unMount();
      fnRef.current.register.mount();
      setLoginOrRegiste('register')
      return
    }
    fnRef.current.register.unMount();
    fnRef.current.login.mount();
    setLoginOrRegiste('login')
  };

  const tips = useMemo(() => {
    const map = {
      register: (
        (<div className={cn(styles.tips, 'DINPro', {
          [styles.darkTip]: theme === THEME.DARK
        })}>{I18n.t('register_has_account')}<span onClick={loginRegisterTabsHandle}>{I18n.t('register_go_login')}</span>
        </div>)
      ),
      login: (
        (<div className={cn(styles.tips, 'DINPro', {
          [styles.darkTip]: theme === THEME.DARK
        })}>
          <span onClick={loginRegisterTabsHandle}>{I18n.t('Sign.up.now')}</span>
        </div>)
      )
    };
    return map[loginOrRegister];
  }, [loginOrRegister]);

  useIsomorphicLayoutEffect(() => {
    fnRef.current.login = initTabLogin({
      el: divRef.current,
      oAuthList: ['Apple', 'Facebook', 'Google'],
      mode: 'popup',
      theme,
      cb: (res) => {
        cb?.(res);
        close?.()
      }
    })
    fnRef.current.register = initTabRegister({
      el: divRef.current,
      theme,
      cb: (res) => {
        cb?.(res);
        close?.()
      },
      mode: 'drawer'
    })
    fnRef.current[defaultType].mount()
  }, [])

  return (
    <div className={cn(styles.container, className)}>
      <h2 className={cn(styles.title, titleClassName, 'DINPro-Medium', {
        [styles.darkTheme]: theme === THEME.DARK
      })}>
        {title[loginOrRegister]}
      </h2>
      <div>{tips}</div>
      <div ref={divRef}></div>
    </div>
  );
};
